module.exports = __webpack_public_path__ + "4eed29992ecbef93ceacec8ff249ab6c.png";